import { useSearchParams } from "react-router-dom";
import Jobs from "./Jobs";

const JobsPage = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  let search = searchParams.get("search");
  let status = searchParams.get("status");

  return <Jobs search={search} status={status ?? "OPEN"} />;
};

export default JobsPage;
